<mat-card>
  <mat-card-header>
    <div
      class="triangle-container"
      [ngStyle]="{ top: (step === 3 ? 235 : 8) + 'px' }"
    >
      <div class="triangle"></div>
    </div>
    <h3>
      {{ 'setUpTwoFactor.authenticatorApp.tooltipTitle' | translate }}
    </h3>
  </mat-card-header>
  <img
    mat-card-image
    ngSrc="./assets/images/mfa-tooltip-steps/{{ authenticator }}-step-{{
      step
    }}.png"
    [alt]="
      'setUpTwoFactor.authenticatorApp.tooltip' +
        (step === 1 ? authenticator : '') +
        step | translate
    "
    height="180"
    width="293"
  />
  <mat-card-content>
    @if (step === 1) {
    <mat-radio-group [(ngModel)]="authenticator">
      @for (provider of authenticators; track $index) {
      <mat-radio-button class="example-radio-button" [value]="provider">{{
        provider + ' Authenticator'
      }}</mat-radio-button>
      }
    </mat-radio-group>
    }
    <div class="navigation">
      @if (step > 1) {
      <button
        mat-stroked-button
        class="navigation-button"
        type="submit"
        (click)="goToStep(step - 1)"
      >
        {{ 'back' | translate }}
      </button>
      } @if (step < 3) {
      <button
        mat-flat-button
        class="navigation-button"
        color="primary"
        type="submit"
        (click)="goToStep(step + 1)"
      >
        {{ 'next' | translate }}
      </button>
      }
    </div>
  </mat-card-content>
</mat-card>
